import styled from "styled-components"
import { skippedOpacity } from "./ExecutionOverlay.styled"

export const NodeContainer = styled.div<{ $skipped?: boolean }>`
  position: relative;
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${p => p.theme.colors.workflows.action};
  border-radius: 0.8rem;
  width: 22rem;
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.1);
  ${skippedOpacity}
`

export const NodeHeader = styled.div`
  background: ${p => p.theme.colors.workflows.action};
  color: ${(p) => p.theme.colors.white};
  padding: 0.6rem 1.2rem;
  border-radius: 0.5rem 0.5rem 0 0;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  ${(p) => p.theme.bold};
`

export const NodeBody = styled.div`
  padding: 1rem 1.2rem;
  font-size: 1.3rem;
  ${(p) => p.theme.bold};
`

export const ActionInfo = styled.div`
  padding: 0 1.2rem 0.8rem;
  font-size: 1.1rem;
  color: ${(p) => p.theme.colors.greyDarker};
`
